import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


import { environment } from '../../../environments/environment';
import { EstadoProgramacionMantenimientoRequest, EstadoProgramacionMantenimientoResponse } from '../model/estados-programacion-mantenimientos.model';

@Injectable({
  providedIn: 'root'
})

export class EstadoProgramacionMantenimientosService {

  private apiUrl = `${environment.apiUrl}/api/estados-programacion-mantenimiento`;

  constructor(private http: HttpClient) { }

 getEstados(): Observable<EstadoProgramacionMantenimientoResponse> {
  return this.http.get<EstadoProgramacionMantenimientoResponse>(
    this.apiUrl
  );
}

}